export const clonePrices = [
  {
    id: 1,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 2,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 3,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 4,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 5,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 7,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 8,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 9,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 11,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 13,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 14,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 24,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 27,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 31,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 32,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 35,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 37,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 38,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 39,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 46,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 47,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 49,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 50,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 51,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 53,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 54,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 55,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 56,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 57,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 64,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 65,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 66,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 67,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 68,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 69,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 70,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 71,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 72,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 74,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 75,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 76,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 77,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 78,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 79,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 80,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 81,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 82,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 83,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 84,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 87,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 88,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 89,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 90,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 91,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 92,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 93,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 101,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 102,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 103,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 104,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 105,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 106,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 107,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 137,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 138,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 139,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 143,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 144,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 145,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 149,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 150,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 151,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 152,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 154,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 158,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 160,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 162,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 180,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 181,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 182,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 4
  },
  {
    id: 183,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 184,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 190,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 201,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 202,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 203,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 204,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 205,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 206,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 207,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 208,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 209,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 210,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 211,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 212,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 213,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 214,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 215,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 216,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 217,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 220,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 5
  },
  {
    id: 221,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 222,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 223,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 224,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 225,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 226,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 227,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 228,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 229,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 5
  },
  {
    id: 230,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 5
  },
  {
    id: 232,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 233,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 234,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 235,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 236,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 237,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 238,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 239,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 3
  },
  {
    id: 240,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 241,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 242,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 243,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 244,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 245,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 247,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 248,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 249,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 250,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 251,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 252,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 4
  },
  {
    id: 253,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 254,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 255,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 256,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 257,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 258,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 3
  },
  {
    id: 259,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 260,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 261,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 262,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 2
  },
  {
    id: 263,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 264,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 2
  },
  {
    id: 265,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 266,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 2
  },
  {
    id: 267,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 268,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 2
  },
  {
    id: 269,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 270,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 271,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 272,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 273,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 274,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 283,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 284,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 285,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 286,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 288,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 289,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 290,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 291,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 292,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 293,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 294,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 295,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 296,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 297,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 298,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 299,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 300,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 301,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 303,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 304,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 305,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 306,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 308,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 309,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 310,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 311,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 313,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 314,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 315,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 319,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 320,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 321,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 322,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 323,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 324,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 325,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 326,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 327,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 328,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 329,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 330,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 331,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 332,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 333,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 334,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 335,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 336,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 337,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 338,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 339,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 340,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 342,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 343,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 344,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 345,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 346,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 347,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 348,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 349,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 350,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 351,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 352,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 353,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 354,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 355,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 356,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 357,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 358,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 359,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 360,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 361,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 362,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 363,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 364,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 365,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 366,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 367,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 370,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 371,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 372,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 373,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 374,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 375,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 376,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 377,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 378,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 379,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 380,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 383,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 384,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 385,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 386,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 387,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 391,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 392,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 393,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 1
  },
  {
    id: 394,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 426,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 427,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 428,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 429,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 462,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 463,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 464,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 465,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 507,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 508,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 509,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 510,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 511,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 512,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 513,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 514,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 515,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 516,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 518,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 519,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 520,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 522,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 523,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 524,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 525,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 526,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 527,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 528,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 529,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 532,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 533,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 534,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 566,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 567,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 568,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 569,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 570,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 572,
    oldPrices: {
      rub: 60000,
      usd: 1200,
      eur: 1000
    },
    additionalGroupId: 11
  },
  {
    id: 573,
    oldPrices: {
      rub: 85000,
      usd: 1600,
      eur: 1400
    },
    additionalGroupId: 11
  },
  {
    id: 574,
    oldPrices: {
      rub: 40000,
      usd: 800,
      eur: 700
    },
    additionalGroupId: 11
  },
  {
    id: 575,
    oldPrices: {
      rub: 300,
      usd: 6,
      eur: 5
    },
    additionalGroupId: 11
  },
  {
    id: 576,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 611,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 612,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 613,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 614,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 615,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 616,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 7
  },
  {
    id: 617,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 618,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 619,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 620,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 621,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 622,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 10
  },
  {
    id: 625,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 627,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 628,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 629,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 630,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 638,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 639,
    oldPrices: {
      rub: 160000,
      usd: 2700,
      eur: 2300
    },
    additionalGroupId: 6
  },
  {
    id: 640,
    oldPrices: {
      rub: 300,
      usd: 6,
      eur: 5
    },
    additionalGroupId: 6
  },
  {
    id: 647,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 648,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 649,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 652,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 653,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 654,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 655,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 656,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 657,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 658,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 659,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 662,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 666,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 667,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 668,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 669,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 670,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 671,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 672,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 673,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 674,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 675,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 676,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 679,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 680,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 681,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 682,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 683,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 684,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 685,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 686,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 687,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 688,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 689,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 691,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 692,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 693,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 694,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 695,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 696,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 697,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 698,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 699,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 702,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 735,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 736,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 737,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 738,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 739,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 740,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 741,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 742,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 743,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 744,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 745,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 746,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 747,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 748,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 749,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 750,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 751,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 752,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 753,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 786,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 787,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 788,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 795,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 796,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 797,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 798,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 805,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 806,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 807,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 808,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 809,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 810,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 811,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 812,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 813,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 814,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 815,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 816,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 817,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 820,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 821,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 823,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 825,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 826,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 827,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 830,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 831,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 832,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 833,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 834,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 835,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 836,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 837,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 838,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 839,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 840,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 841,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 842,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 845,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 5
  },
  {
    id: 846,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 847,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 851,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 852,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 853,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 854,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 855,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 856,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 857,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 858,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 5
  },
  {
    id: 859,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 860,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 861,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 862,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 863,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 864,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 865,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 867,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 868,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 869,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 870,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 871,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 872,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: 12
  },
  {
    id: 873,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 874,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 876,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 877,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 878,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 879,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 880,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 883,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 884,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 885,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 886,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 887,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 890,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 892,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 893,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 894,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 895,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  },
  {
    id: 897,
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    },
    additionalGroupId: null
  }
]